import isLeapYear from './isLeapYear';

enum Months {
	/**
	 * 31 Days
	 */
	JANUARY = 1,
	/**
	 * 28 or 29 Days
	 */
	FEBRUARY = 2,
	/**
	 * 31 Days
	 */
	MARCH = 3,
	/**
	 * 30 Days
	 */
	APRIL = 4,
	/**
	 * 31 Days
	 */
	MAY = 5,
	/**
	 * 30 Days
	 */
	JUNE = 6,
	/**
	 * 31 Days
	 */
	JULY = 7,
	/**
	 * 31 Days
	 */
	AUGUST = 8,
	/**
	 * 30 Days
	 */
	SEPTEMBER = 9,
	/**
	 * 31 Days
	 */
	OCTOBER = 10,
	/**
	 * 30 Days
	 */
	NOVEMBER = 11,
	/**
	 * 31 Days
	 */
	DECEMBER = 12,
}

interface MonthAndYear {
	month?: string;
	year?: string;
}

export default function getLastDayOfTheMonth({ month, year }: MonthAndYear) {
	if (month) {
		switch (parseInt(month)) {
			case Months.FEBRUARY:
				if (!year || isLeapYear(parseInt(year))) {
					return 29;
				}
				return 28;
			case Months.APRIL:
			case Months.JUNE:
			case Months.SEPTEMBER:
			case Months.NOVEMBER:
				return 30;
		}
	}
	return 31;
}
